import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters({
			user: 'auth/getUser',
		}),

		// Retorna a URI da página
		originURL() {
			return window.location.href
		},

		// Retorna a característica da URI
		featureURL() {
			const parts = this.originURL.split('/')
			const lastValue = parts[parts.length - 1]
			const beforeLastValue = parts[parts.length - 2]

			return this.userGroup === 'broker' && lastValue === '' ? 'dashboard' : `${beforeLastValue}/${lastValue}`
		},

		// Retorna a identidade do usuário (instance + user_id)
		userIdentity() {
			if (!this.user) return undefined

			return this.user.identity
		},

		// Retorna o nome do usuário
		userName() {
			if (!this.user) return undefined

			return this.user.first_name
		},

		// Retorna o email do usuário
		userEmail() {
			if (!this.user) return undefined

			return this.user.email
		},

		// Retorna o celular do usuário
		userMobile() {
			if (!this.user) return undefined

			return this.user.mobile === null || this.user.mobile === '' ? '(00)000000000' : this.user.mobile
		},

		// Retorna o grupo do usuário
		userGroup() {
			if (!this.user) return undefined

			if (this.user.isDynamicGroup) return 'dynamic'

			return this.user.user_group
		},

		// Retorna o button habilitado
		canSubmit() {
			return this.filters[0].params.value &&
				this.sendMessage.length > 3 &&
				this.buttonSatisfied === true
				? true : false
		},
	},
}
